// @flow

import { Component } from '../../jsti/core';
import { camelToKebab } from '../../classes/Helpers';

export default class BaseComponent extends Component {
  /**
   * Dynamically set properties on the class.
   * Property value must be a HTMLElement
   *
   * @param properties
   */
  setProperties(properties: Array<string>): void {
    for (const property: string of properties) {
      const search = camelToKebab(property);
      const element: ?HTMLElement = this.el.getElementByRef(search);
      if (element) {
        this[property] = element;
      } else {
        throw new Error(`${property} is required`);
      }
    }
  }
}
